import { getABTProvider } from '@/plugins/abt/statsig'

export const MERCHANT_ORDERS_LIST_V2_FLAG = 'gate_temp_merchant_orders_list_v2'

export const ORDER_LIST_PATH_V1 = '/order/list'
export const ORDER_LIST_PATH_V2 = '/v2/orders'

export const ORDER_DETAIL_PATH = '/order/detail/:orderId'
export const ORDER_DETAIL_PATH_V2 = '/v2/orders/detail/:orderId'

export function isMerchantOrdersListV2Enabled() {
  return getABTProvider().isFeatureEnabled(MERCHANT_ORDERS_LIST_V2_FLAG)
}

export function getOrderListPath() {
  return isMerchantOrdersListV2Enabled()
    ? ORDER_LIST_PATH_V2
    : ORDER_LIST_PATH_V1
}

export function getOrderDetailPath() {
  return isMerchantOrdersListV2Enabled()
    ? ORDER_DETAIL_PATH_V2
    : ORDER_DETAIL_PATH
}

export function buildOrderDetailPath(orderId) {
  return getOrderDetailPath().replace(':orderId', orderId)
}

function getOrderIdFromDetailPath(path = '') {
  const match = path.match(/\/detail\/([^/?]+)/)
  return match?.[1]
}

export function redirectToOrderDetailPath(to = {}) {
  const orderId = to.params?.orderId || getOrderIdFromDetailPath(to.path)
  const query = to.query || {}
  const queryString =
    Object.keys(query).length > 0
      ? '?' + new URLSearchParams(query).toString()
      : ''

  window.location.replace(
    window.location.origin + buildOrderDetailPath(orderId) + queryString
  )
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function navigateToOrderDetail(router, orderId, { query } = {}) {
  if (isMerchantOrdersListV2Enabled()) {
    redirectToOrderDetailPath({ params: { orderId }, query })
    return
  }

  router.push({ path: buildOrderDetailPath(orderId), query })
}

/** Flat logical keys shared by callers; bracket keys are V1-only. */
function toLogicalOrderListQuery(query = {}) {
  const logical = { ...query }

  if (logical['searchText[like]'] !== undefined) {
    logical.searchText = logical['searchText[like]']
    delete logical['searchText[like]']
  }

  if (logical['status[eq]'] !== undefined) {
    logical.status = logical['status[eq]']
    delete logical['status[eq]']
  }

  return logical
}

function toV1OrderListQuery(logical) {
  const query = { ...logical }

  if (query.searchText !== undefined) {
    query['searchText[like]'] = query.searchText
    delete query.searchText
  }

  if (query.status !== undefined) {
    query['status[eq]'] = query.status
    delete query.status
  }

  return query
}

function toV2OrderListQuery(logical) {
  return { ...logical }
}

/**
 * Normalizes order-list query params for the active app version.
 * Pass logical keys (searchText, status); V1 bracket keys in URLs are accepted too.
 */
export function buildOrderListQuery(query = {}) {
  const logical = toLogicalOrderListQuery(query)

  return isMerchantOrdersListV2Enabled()
    ? toV2OrderListQuery(logical)
    : toV1OrderListQuery(logical)
}

export function redirectToOrderListPath(to = {}) {
  const query = buildOrderListQuery(to.query || {})
  const queryString =
    Object.keys(query).length > 0
      ? '?' + new URLSearchParams(query).toString()
      : ''

  window.location.replace(
    window.location.origin + getOrderListPath() + queryString
  )
}

/** V2 lives outside the hash router — use full-page navigation when the flag is on. */
export function navigateToOrderList(router, { query } = {}) {
  const normalizedQuery = buildOrderListQuery(query)

  if (isMerchantOrdersListV2Enabled()) {
    redirectToOrderListPath({ query: normalizedQuery })
    return
  }

  router.push({ path: ORDER_LIST_PATH_V1, query: normalizedQuery })
}
